import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getWhatsappProfile = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-whatsapp-profile',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
    });
}